module.exports = __webpack_public_path__ + "img/pantalla 7-1.c550cb64.svg";